import { PublicKey } from '@solana/web3.js';
import { capturePostHogEvent } from 'src/providers/posthog/posthogConfig';
import {
	MarketId,
	ServerAuctionParamsResponse,
} from '@velocity-exchange/common';
import useMarketStateStore from 'src/stores/useMarketStateStore';
import {
	getLiveMarkPrice,
	getLiveMmOracleData,
	getLiveOracleData,
	getLiveOracleForDisplay,
} from 'src/stores/marketLiveState';
import { safeCheckDevSwitchIsOn } from 'src/hooks/useDevSwitchIsOn';

// Intentionally reads live state imperatively for diagnostics — logs the
// freshest oracle/mark/orderbook numbers at order time.
export const logOrderParams = (
	marketId: MarketId,
	userAccountPubKey: PublicKey,
	urlParams: URLSearchParams,
	response: ServerAuctionParamsResponse
) => {
	const marketState = useMarketStateStore
		.getState()
		.getMarketDataForMarket(marketId);

	const mmOraclePrice = getLiveMmOracleData(marketId)?.price?.print();
	const regularOraclePrice = getLiveOracleData(marketId)?.price?.print();
	const oraclePrice = getLiveOracleForDisplay(marketId)?.price?.print();

	const urlParamsObject: Record<string, string> = {};
	urlParams.forEach((value, key) => {
		urlParamsObject[key] = value;
	});

	if (safeCheckDevSwitchIsOn()) {
		console.log('[logOrderParams] auction params', {
			marketId: marketId.key,
			userAccountPubKey: userAccountPubKey.toString(),
			requestParams: urlParamsObject,
			response,
		});
	}

	capturePostHogEvent('trade_order_params_requested', {
		user_account_pubkey: userAccountPubKey,
		url_params: urlParamsObject,
		oracle_price: oraclePrice,
		mm_oracle_price: mmOraclePrice,
		regular_oracle_price: regularOraclePrice,
		derived_market_state: marketState?.derivedState
			? {
					mark_price: getLiveMarkPrice(marketId)?.print() ?? '',
					best_bid: marketState.derivedState.bestBid.print(),
					best_ask: marketState.derivedState.bestAsk.print(),
					update_slot: marketState.derivedState.updateSlot,
				}
			: undefined,
		endpointResponse: response,
	});
};
